import colors from 'colors'
import { Result } from 'types'
import React, { FC } from 'react'
import styled, { CSSProperties } from 'styled-components'
import Cell from './Cell'

const Container = styled.div`
  padding: 16px;
  margin: 16px 0;
  background-color: white;
  border-radius: 8px;
`
const MainText = styled.p`
  margin: 0;
  color: ${colors.black};
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`
const List = styled.div`
  margin: 16px 0;
`

const ExchangeList: FC<{ result: Result; style?: CSSProperties }> = ({
  result,
  style,
}) => {
  return (
    <Container style={style}>
      <MainText>{result.desc}</MainText>
      <List>
        {result.exchanges.map((a, idx) => (
          <Cell key={a.code} exchange={a} idx={idx}></Cell>
        ))}
      </List>
    </Container>
  )
}

export default ExchangeList
